import { Box } from '@primer/react';
import { Valence } from '@upright/common/model/types';
import { valenceTextColorPrimer } from '@upright/ui/common/generic/utilities/format';
import { ElementType, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';
interface Props {
  valence: Valence.NEGATIVE | Valence.POSITIVE;
  icon: ElementType;
}

export const ValencedSubHeaderWithIcon = (props: PropsWithChildren<Props>) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
    <IconWrapper valence={props.valence}>
      <props.icon width={16} height={16} />
    </IconWrapper>
    <Box
      as="h3"
      sx={{
        fontSize: 12,
        color: valenceTextColorPrimer(props.valence),
      }}
    >
      {props.children}
    </Box>
  </Box>
);

const IconWrapper = styled.div<{ valence: Valence.NEGATIVE | Valence.POSITIVE }>`
  background-color: ${props =>
    props.valence === Valence.POSITIVE
      ? themeGet('colors.impact.positive.weak')
      : themeGet('colors.impact.negative.weak')};
  border-radius: 50%;
  padding: 2px;
  color: ${props => themeGet(`colors.${valenceTextColorPrimer(props.valence)}`)};
`;
